import { User, UserContext } from '../models';
import { UserProfileViewModel } from '../viewModels';

export class UserMapper {
  static convertFromUserProfileViewModelToUser(userProfile: UserProfileViewModel): User {
    const user: User = User.Empty();
    if (userProfile) {
      user.id = userProfile.id;
      user.name = userProfile.name;
      user.email = userProfile.email;
      user.status = 'active';
    }
    return user;
  }

  static convertFromUserProfileViewModelToUserContext(userProfile: UserProfileViewModel, tenantId: string): UserContext {
    const userContext: UserContext = new UserContext();
    if (userProfile) {
      userContext.name = userProfile.name;
      userContext.email = userProfile.email;
      userContext.picture = userProfile.picture;
      userContext.hasLoggedIn = userProfile.hasLoggedIn;
    }
    return userContext;
  }

  static convertToUserProfileViewModelFromUserContext(userContext: UserContext): UserProfileViewModel {
    const userProfile: UserProfileViewModel = new UserProfileViewModel();
    if (userContext) {
      userProfile.name = userContext.name;
      userProfile.email = userContext.email;
      userProfile.picture = userContext.picture;
      userProfile.hasLoggedIn = userContext.hasLoggedIn;
    }
    return userProfile;
  }
}
